import React, { useState } from "react";
import "./ForgotPassword.scss";
import Logo from "../../assets/Logo.png";
import Logo_Banner from "../../assets/logo_banner.png";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { webEndPoint } from "../../constant/constant";
import { makeRequest } from "../../services/api";
import AlertModal from "../../components/Modals/AlertModal";
import Loader from "../../components/Loader/Loader";
import { setItem } from "../../services/utilities";
import Verify_btn from "../../assets/verify_btn.png";

function ForgotPassword() {
  let navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const onSubmit = (data) => {
    sentOtp({
      email: data.email,
    });
  };
  const sentOtp = async (data) => {
    try {
      setLoading(true);
      let url = webEndPoint + "auth/forgot-password-email";
      const response = await makeRequest("post", url, data);
      if (response) {
        setItem("userOtpDetail", JSON.stringify(response));
        setLoading(false);
        navigate("/verify_code");
      }
    } catch (err) {
      setLoading(false);
      setErrorMsg(JSON.stringify(err?.alert) || 'Invalid Email id');
      setOpenModal(true);
    }
  };
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Loader loading={loading} />
      <div className="grid">
        <div className="order__left centered">
          <div className="form">
            <img
              className="astro_logo centered"
              src={Logo}
              alt="astrocure_logo"
            />
            <p className="forgot-password-header-text">Forgot Password</p>
            <p className="forgot-description-text">
              Enter the email address associated with your account, then check
              your email for a verification code. If you forgot your email,
              please contact us.
            </p>
            <div>
              <div className="fullname-input-container-sign">
                <label className="fullname-label">
                  Email Id <span className="fullname-required">*</span>
                </label>
                <input
                  {...register("email", { required: true })}
                  type="text"
                  id="email"
                  name="email"
                  className="forgot_input_style"
                  placeholder="Enter your email address"
                  autoComplete="off"
                  required
                />
              </div>
              {errors.email && (
                <p className="alert_msg">Email Id is required.</p>
              )}
            </div>
            <div className="fullname-input-container-sign">
              <button type="submit" class="send_otp login__text">
                Send Verification Code
              </button>
            </div>
            <div className="fullname-input-container-sign">
              <button
                type="submit"
                class="forgot__button forgot__text"
                onClick={() => navigate("/")}
              >
                Back to Login
              </button>
            </div>
            <div class="signup">
              <label className="copy_right_text">
                Copyright © 2025 Astrovidhi Private Limited All rights reserved
              </label>
            </div>
          </div>
        </div>
        <div className="order__right no__overflow banner">
          <img className="banner__image" src={Logo_Banner} alt="banner" />
        </div>
      </div>
      <AlertModal open={openModal} setOpen={setOpenModal} errorMsg={errorMsg} />
    </form>
  );
}

export default ForgotPassword;
